import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { DayOfWeek } from '../../../enums/DayOfWeek';
import { Availability } from '../../../models/employee/Availability';
import { EmployeeWeeklyAvailabilityResponse } from '../../../../interfaces/response/EmployeeResponse';

/**
 * An adapter converts availability HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class AvailabilityAdapter implements Adapter<Map<string, Availability[]>> {

  /**
   * Converts availability HTTP response to a map of date to a list of {@link Availability}.
   * @param item availability HTTP response.
   */
  adapt(item: EmployeeWeeklyAvailabilityResponse[]): Map<string, Availability[]> {
    if (!item) {
      return null;
    }
    const result = new Map<string, Availability[]>();
    item.map($item => {
      const monday = $item.monday;
      const tuesday = $item.tuesday;
      const wednesday = $item.wednesday;
      const thursday = $item.thursday;
      const friday = $item.friday;
      const saturday = $item.saturday;
      const sunday = $item.sunday;
      const weeklyAvailabilities: Availability[] = [];
      if (monday) {
        weeklyAvailabilities.push(new Availability(DayOfWeek.MONDAY, monday.startTime, monday.endTime, $item.date));
      }
      if (tuesday) {
        weeklyAvailabilities.push(new Availability(DayOfWeek.TUESDAY, tuesday.startTime, tuesday.endTime, $item.date));
      }
      if (wednesday) {
        weeklyAvailabilities.push(new Availability(DayOfWeek.WEDNESDAY, wednesday.startTime, wednesday.endTime, $item.date));
      }
      if (thursday) {
        weeklyAvailabilities.push(new Availability(DayOfWeek.THURSDAY, thursday.startTime, thursday.endTime, $item.date));
      }
      if (friday) {
        weeklyAvailabilities.push(new Availability(DayOfWeek.FRIDAY, friday.startTime, friday.endTime, $item.date));
      }
      if (saturday) {
        weeklyAvailabilities.push(new Availability(DayOfWeek.SATURDAY, saturday.startTime, saturday.endTime, $item.date));
      }
      if (sunday) {
        weeklyAvailabilities.push(new Availability(DayOfWeek.SUNDAY, sunday.startTime, sunday.endTime, $item.date));
      }
      result.set($item.date, weeklyAvailabilities);
    });
    return result;
  }
}
